import { useState, useEffect, useCallback } from 'react';
import API from '../api/api';

const useGetLocations = (role) => {
    const [locations, setList] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const request = await API.get('/get_locations');
            
            if (request.data.data) {
                setList(request.data.data);
                setError(null);
            } 
        }
        catch(error) {
          if (error?.status === 401) {
              return;
            }
            if (error.status === 403) {return;} 
          setError(error);
      } 
        finally {
            setLoading(false);
        }
    }, [role]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);
    
    return { locations, loading, error, refetch: fetchData };
}

export default useGetLocations;